import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["info"]

  declare readonly infoTarget: HTMLElement

  add(event: Event): void {
    const target = event.target as HTMLInputElement;
    const fileName = target.value.split('\\').pop();
    this.infoTarget.innerHTML = fileName || '';
  }
}
